import type { Screen } from "../app/api/ApiClient";
import { ApiClient } from "../app/api/ApiClient";
import { AuthManager } from "../app/auth/AuthManager";

import type { StateStore } from "../app/state/StateStore";

export class NavigationController {

    constructor(

        private readonly api: ApiClient,

        private readonly auth: AuthManager,

        private readonly store: StateStore,

        private readonly applyScreen: (
            screen: Screen
        ) => void

    ) {}

    // =====================================================
    // CORE
    // =====================================================

    public async completeClicked(): Promise<void> {

        const state =
            this.store.getState();

        if (!state.currentKrokId) {
            return;
        }

        const res =
            await this.api.complete(
                state.currentKrokId
            );

        this.applyScreen(
            res.screen
        );

    }

    public async prevClicked(): Promise<void> {

        const state =
            this.store.getState();

        const id =
            state.krok?.prev_krok_id;

        if (!id) {
            return;
        }

        const res =
            await this.api.navigate(id);

        this.applyScreen(
            res.screen
        );

    }

    public async nextClicked(): Promise<void> {

        const state =
            this.store.getState();

        const id =
            state.krok?.next_krok_id;

        if (!id) {
            return;
        }

        const res =
            await this.api.navigate(id);

        this.applyScreen(
            res.screen
        );

    }

    public async entryClicked(): Promise<void> {

        const res =
            await this.api.entryKrok();

        this.applyScreen(
            res.screen
        );

    }

    public async openKrok(
        krokId: string
    ): Promise<void> {

        const res =
            await this.api.navigate(
                krokId
            );

        this.applyScreen(
            res.screen
        );

    }

}